var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status !== 0)?_c('div',[(_vm.status === 1)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":""}}):_vm._e(),(_vm.status === 2)?_c('api-errors-viewer',{attrs:{"errors":_vm.data}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }